import PropTypes from 'prop-types';
import { useIsUserAuthorized } from '../../stores/SessionStore';

export default function AuthorizedUserGuard({ children, unauthorized }) {
    const isAuthorized = useIsUserAuthorized();

    return isAuthorized ? children : unauthorized;
}

AuthorizedUserGuard.propTypes = {
    children: PropTypes.node,
    unauthorized: PropTypes.node,
};

AuthorizedUserGuard.defaultProps = {
    children: null,
    unauthorized: null,
};
